import { PaginationState } from '@tanstack/react-table';
import { Dispatch, SetStateAction, useState } from 'react';

/** Scalars only, so a caller cannot make the identity throw or key-order-drift through this slot. */
export type QueryScopePart = string | number | boolean | null | undefined;

/**
 * Sends the table back to page 0 whenever the inputs that narrow the result set change.
 * A page index only means anything relative to the query that produced it — page 3 of a
 * 500-row set does not exist once a filter cuts that set to 30.
 *
 * Adjusts state during render rather than in an effect, so the corrected page index is
 * used by the same commit and no request goes out for the stale page.
 */
export const useResetPageOnQueryChange = (
	identityParts: readonly unknown[],
	pagination: PaginationState,
	setPagination: Dispatch<SetStateAction<PaginationState>>
): void => {
	const identity = JSON.stringify(identityParts);
	const [prevIdentity, setPrevIdentity] = useState(identity);

	if (identity !== prevIdentity) {
		setPrevIdentity(identity);
		if (pagination.pageIndex !== 0) {
			setPagination((prev) => ({ ...prev, pageIndex: 0 }));
		}
	}
};
